// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"5a272221","164":"2090b1a6","189":"f9fe4062","270":"5a64c995","351":"27c17931","444":"2691b76a","540":"2428433e","553":"323d22cb","767":"365153e8","803":"43575d8c","917":"158f668d","964":"7c0b7694","984":"7fe7315d"}[chunkId] + ".chunk.js";
};